import { createApp } from 'vue'
import { initApp } from '@/plugins/app-pre-init'
import signUp from '@/pages/log-in/log-in.vue'
import '@/index.css'

initApp(createApp(signUp), true).then((app) => app
    .mount('#app')
);

